
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.176 15.481a1.676 1.676 0 100 3.352 1.676 1.676 0 000-3.352zm0-5.16a1.677 1.677 0 10.002 3.354 1.677 1.677 0 00-.002-3.354zm0-4.821a1.676 1.676 0 100 3.352 1.676 1.676 0 000-3.352zm3.656 13.346h10.337v-3.202H9.832zm.001-5.048H20.17v-3.202H9.833zm0-5.048H20.17V5.548H9.833z","fill":"#FFF","fill-rule":"evenodd"}})])
          )
        }
      }
    